import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(-1),
    gap: theme.spacing(1),
  },
  acceptanceTermsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  acceptanceText: {
    fontSize: '16px',
    margin: theme.spacing(0),
    lineHeight: '24px',
    letterSpacing: '0.5px',
  },
  acceptanceTermDetailsContainer: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  acceptanceTermDetails: {
    margin: theme.spacing(0),
    fontSize: '14px',
    color: theme.palette.labraText.description,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  errorText: {
    color: theme.palette.labraV2Errors.main,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.25px',
  },
}))
